import mapValues from 'lodash/mapValues';
import React from 'react';
import styled from 'styled-components';
import { cssVars } from '../../../app/styles';
import { getNewPlatformIcon } from '../../../widgets/components/online-platform-icon';
import { ENDPOINT_DATE_FORMAT, splitDateRangesByMonth } from '../dates';

const ListingEventContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

function getColorForListing(listing) {
  return (
    cssVars.propertyHistoryColors.platformColors[listing.platform] ||
    cssVars.propertyHistoryColors.unknownPlatformColor
  );
}

const capitalize = (s) => s[0].toUpperCase() + s.slice(1);

//
function getListingEventContent(listing) {
  const Icon = getNewPlatformIcon(listing.platform);

  return (
    <ListingEventContent>
      <Icon />
      {listing.id}
    </ListingEventContent>
  );
}

function combineObjects(o1, o2, valueCombiner) {
  const allKeys = Array.from(new Set([...Object.keys(o1), ...Object.keys(o2)]));

  return allKeys.reduce(
    (acc, key) => ({
      ...acc,
      [key]: valueCombiner(o1[key], o2[key]),
    }),
    {}
  );
}

export function getListingLivePartialEventsByMonth(listings) {
  const eventsByListingIdByMonth = listings.reduce((acc, lst) => {
    const listingLiveEventsByMonth = splitDateRangesByMonth(
      lst?.liveDates || []
    );

    return combineObjects(
      acc,
      listingLiveEventsByMonth,
      (listingIdToEvents, listingEvents) => ({
        ...listingIdToEvents,
        [lst.id]: listingEvents,
      })
    );
  }, {});

  return mapValues(eventsByListingIdByMonth, (eventsByListingId) =>
    listings.map((lst) => ({
      listing: lst,
      events: eventsByListingId[lst.id] || [],
    }))
  );
}

export function getListingLiveCompleteEvents({ events, listing }) {
  const augmentedEvents = events.map((evt) => {
    const {
      originalRangeDates: { start, end },
    } = evt;

    return {
      ...evt,
      contents: getListingEventContent(listing),
      style: {
        background: getColorForListing(listing),
        textAlign: 'left',
        padding: '0 10px',
        display: 'flex',
        alignItems: 'center',
      },
      additionalProps: {
        'aria-label': `${capitalize(listing.platform)} Listing #${
          listing.id
        } Live ${start.format(ENDPOINT_DATE_FORMAT)} - ${end.format(
          ENDPOINT_DATE_FORMAT
        )}`,
        'data-balloon-pos': 'down',
      },
    };
  });

  return { listing, events: augmentedEvents };
}
